import React from 'react';
import styled from "styled-components"

const PrimaryBtn = ({label, handleBtn}) => {
  return (
    <SaveBtn onClick={handleBtn} >{label}</SaveBtn>

  );
};

export default PrimaryBtn;
const SaveBtn = styled.button`
  cursor: pointer;
  background: ${({theme}) => theme.accent};
  border: none;
  width: 10rem;
  color: #fff;
  float: right;
  height: 3rem;
  margin: 1rem 0;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
`